import * as Sentry from '@sentry/react'
import type { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  retainSearchParams,
} from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Toaster } from 'sonner'
import { BackgroundOrnaments } from '@/components/decorative/background-ornaments'
import { NotFoundError } from '@/components/error/not-found-error'
import { UnexpectedError } from '@/components/error/unexpected-error'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: Root,
  search: {
    // Automatically retain the search params that are commonly passed around, to avoid forgetting
    middlewares: [retainSearchParams(['gameId', 'handoffId', 'upgradeId'])],
  },
  // onCatch and errorComponent go hand in hand. When errorComponent is shown, onCatch is called.
  onCatch: (error) => {
    Sentry.captureException(error)
  },
  errorComponent: UnexpectedError,
  notFoundComponent: NotFoundError,
})

function Root() {
  return (
    <>
      <HeadContent />

      <BackgroundOrnaments />

      {/* Before the page, so the Toaster subscribes before page effects can toast on mount. */}
      <Toaster position="top-center" />

      <main>
        <Outlet />
      </main>

      {/* These devtools interfere with Playwright tests, so we just hide them */}
      {/* It currently isn't super useful in local dev too, so this is just kept for posterity */}
      {/* Turn it to true when you need them */}
      {false && (
        <>
          <ReactQueryDevtools buttonPosition="bottom-left" />
          <TanStackRouterDevtools position="bottom-right" />
        </>
      )}
    </>
  )
}
